import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import PMDashboard from './pages/PMDashboard';
import CreatePO from './pages/CreatePO';
import AssignPO from './pages/AssignPO';
import ViewProgress from './pages/ViewProgress';
import EditPO from './pages/EditPO';
import POList from './pages/POList';
import POdetail from './pages/POdetail';
import ManageUsers from './pages/ManageUsers';
import { useAuth } from './context/AuthContext';
import ClientWisePO from './pages/ClientWisePO';
import VendorMaterialManager from './pages/VendorMaterialManager';
import POByJC from './pages/POByJC';
import VendorDetails from './pages/VendorDetails';
import VendorWiseDetails from './pages/VendorWiseDetails';
import POMaterialDemanded from './pages/POWiseMaterialDemanded';
import AdminMaterials from './pages/AdminMaterials';
import MaterialCalculator from './components/MaterialCalculator/MaterialCalculator';
import AddHeading from './components/MaterialCalculator/AddHeading';
import AddMaterial from './components/MaterialCalculator/AddMaterial';
import AddFormula from './components/MaterialCalculator/AddFormula';
import FormulaEditor from './components/MaterialCalculator/FromulaEditor';
import RAAfterAprilPage from './pages/RAAfterApril';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, role, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!user || !allowedRoles.includes(role)) return <Navigate to="/" replace />;

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<LoginPage />} />

        {/* Admin Routes */}
        <Route
          path="/admin"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route path="/admin/vendor-details" element={<PrivateRoute allowedRoles={['admin']}><VendorDetails /> </PrivateRoute>} />
        <Route path="/admin/vendor/:vendorId" element={<PrivateRoute allowedRoles={['admin']}><VendorWiseDetails /> </PrivateRoute>} />
        <Route
          path="/admin/create-po"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <CreatePO />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/assign-po"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <AssignPO />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/view-progress"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <ViewProgress />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/edit-po"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <EditPO />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/po-list"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <POList />
              </PrivateRoute>
          }
        />
        <Route
          path="/admin/po-detail/:id"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <POdetail />
              </PrivateRoute>
   
          }
        />
         <Route
          path="/admin/manage-users"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <ManageUsers />
              </PrivateRoute>
   
          }
        />
        
        <Route path="/po-by-jc" element={<POByJC />} />
        <Route
          path="/admin/client-wise"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <ClientWisePO />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/vendor-material-manager"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <VendorMaterialManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/materials"
          element={
            <PrivateRoute allowedRoles={['admin']}>
              <AdminMaterials />
            </PrivateRoute>
          }
        />
        <Route path="/admin/ra-after-april" element={<PrivateRoute allowedRoles={['admin']}> <RAAfterAprilPage /> </PrivateRoute>} />

       
        <Route path="/admin/view-progress/:pmId" element={<PrivateRoute allowedRoles={['admin']}><ViewProgress /> </PrivateRoute>} />
        <Route
          path="/pm"
          element={
            <PrivateRoute allowedRoles={['pm']}>
              <PMDashboard />
            </PrivateRoute>
          }
        
        />
         {/* <Route path="/material-formula-manager" element={ <MaterialFormulaManager />}/>
         <Route path="/material-calculator" element={ <MaterialCalculator />}/>
         <Route path="/material-viewer" element={ <MaterialViewer />}/> */}
             <Route path="/material-calculator" element={<MaterialCalculator />} />
    <Route path="/material-calculator/add-heading" element={<AddHeading />} />
    <Route path="/material-calculator/add-material" element={<AddMaterial />} />
    <Route path="/material-calculator/add-formula" element={<AddFormula />} />
    <Route path="/material-calculator/formula-editor" element={<FormulaEditor />} />
        <Route path="/po-wise-material-demanded/:jcNumber" element={ <PrivateRoute allowedRoles={['pm']}><POMaterialDemanded /></PrivateRoute>} />
       
      </Routes>
      

    </Router>
  );
}

export default App;
